<template>
  <div class="base-spinner fa-3x">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</template>

<script>
  export default {
    name: 'loading',
    data () {
      return {
      }
    }
  }
</script>

<style lang="scss" scoped>
  .base-spinner {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
    width: 100%;
    height: 100%;
    display: flex;
    color: #ffa500;
    position: absolute;
    align-items: center;
    justify-content: center;
    background-color: #FFFFFF;
  }
</style>
